import { render, staticRenderFns } from "./Lupatakalaluan.vue?vue&type=template&id=c90f4388&scoped=true"
import script from "./Lupatakalaluan.vue?vue&type=script&lang=js"
export * from "./Lupatakalaluan.vue?vue&type=script&lang=js"
import style0 from "./Lupatakalaluan.vue?vue&type=style&index=0&id=c90f4388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90f4388",
  null
  
)

export default component.exports